import React, { useEffect, useRef, useState } from 'react'
import { PostData } from '../../containers/Services/PostData';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { ApiService } from '../../containers/Services/apiservice';
import { Helmet } from 'react-helmet';
import { Watch } from "react-loader-spinner";
import {
  BrowserRouter as Router,
  Link,
  Route,
  Routes,
  useParams,
} from "react-router-dom";
let apiServices = new ApiService();
const Pages = () => {
  const { slug } = useParams();
  const [pageContent, setPageContent] = useState('');
  const [pageTitle, setPageTitle] = useState('');
  const [pageKeywords, setPageKeywords] = useState('');
  const [pageDescription, setPageDescription] = useState('');
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [pageChange, setPageChange] = useState(1)
  const didMountRef = useRef(true);
 useEffect(() => {
    if (didMountRef.current) {
      setSpinnerLoading(true);
      // setTimeout(() => {
      //   setSpinnerLoading(false);
      // }, 2500);
      const dataString = {
        "url": slug
      }
      apiServices.pagesPostRequest(dataString).then(res => {
        if (res.data.status == 'success') {
          setPageContent(res.data.data.page_content);
          setPageTitle(res.data.data.page_name);
          setPageKeywords(res.data.data.page_meta_keyword);
          setPageDescription(res.data.data.page_meta_desc);
          setSpinnerLoading(false);
        }
        else {
          setPageChange(2)
        }
      })
    }
    didMountRef.current = false;
  });
  return (
    <div>
      {pageChange == 1 ?
        <>
          <Header />
          <Helmet>
            <title>{pageTitle} Goalstox</title>
            <meta name="keywords" content={pageKeywords} />
            <meta name="description" content={pageDescription} />
          </Helmet>
          <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
            <div className='overlay-box'>
              <Watch
                color="#ffffff"
                visible={spinnerLoading}
              />
            </div>
          </div>
          <div dangerouslySetInnerHTML={{ __html: pageContent }}></div>
          <Footer />
        </>
        : ""}
      {pageChange == 2 ?
        <>
          <Header />
          <div style={{ textAlign: "center", marginTop: "27px" }}>
            <div className='mb-5'>
              <img src='/img/pagenorfound.png' />
            </div>
            <p className='mb-0'>The Page that you are looking for is either getting updated or there's server issue.</p>
            <p>Kindly revisit again at: <a href="/">https://goalstox.com/</a></p>
            <p>If the issue pertains, Mail us at: <a href="mailto:help@goalstox.com">help@goalstox.com</a></p>
          </div>
          <Footer />
        </>
        : ""}
    </div>
  )
}
export default Pages;
